import React, { Component } from 'react'
import 'HELPDESK/Components/QueryDetails/AddRequestModal/ProductCustomization/Enhancements/enhancements.css';
import attachmentImage from "HELPDESK/CommonResources/images/attachment1.png";
import { toast } from 'react-toastify';
import HelpdeskApiCall from 'HelpdeskApiCall';
import config from 'config';
import { Base64 } from 'js-base64';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import Select from 'react-select';

export class Enhancements extends Component {
    constructor(props) {
        super(props)
        this.fileInputRef = React.createRef();

        this.state = {
            serviceRequestTitle: this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0 ? Object.values(this.props.currentClientResponse)[0].querySubject : '',
            explanation: this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0 ? Object.values(this.props.currentClientResponse)[0].queryDescription : '',
            moduleId: this.props.moduleId,
            subModuleId: this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0 ? Object.values(this.props.currentClientResponse)[0].subModuleId : '',
            moduleName: this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0 ? Object.values(this.props.currentClientResponse)[0].moduleName : this.props.selectedModuletab,
            subModuleName: this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0 ? Object.values(this.props.currentClientResponse)[0].subModuleName : '',
            applicationTypes: this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0
                ? [{
                    label: Object.values(this.props.currentClientResponse)[0].queryOccurredIn,
                    value: Object.values(this.props.currentClientResponse)[0].queryOccurredIn
                }]
                : [],
            purpose: this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0 ? Object.values(this.props.currentClientResponse)[0].purpose : '',
            currentFlow: this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0 ? Object.values(this.props.currentClientResponse)[0].desiredFeature : '',
            featureFlow: this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0 ? Object.values(this.props.currentClientResponse)[0].currentFeature : '',
            selectedTargetElements: this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0
                ? Object.values(this.props.currentClientResponse)[0].targetedElements.map(item => ({
                    label: item,
                    value: item
                }))
                : [],
            accountType: this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0 ? Object.values(this.props.currentClientResponse)[0].accountType : '',

            attachments: [],
            location: '',
            locationObjectArray: [],
            attachmentFileArray: [],
            selectedAttachment: [],
            //   "Institute,Employee,Department"
            customizationImpacts: this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0 ? Object.values(this.props.currentClientResponse)[0].changeImpactOn.split(",").map(item => ({
                label: item,
                value: item
            })) : [],

            serviceRequestTitleWarning: '',
            explanationWarning: '',
            moduleWarning: '',
            purposeWarning: '',
            subModuleWarning: '',
            targetElementsWarning: '',
            customizationImpactsWarning: '',
            applicationTypeWarning: '',
            currentFlowWarning: '',
            featureFlowWarning: '',
            attachmentsWarning: '',
            accountTypeWarning: '',
            addLocation: false,




            filterOptions: [
                { label: "Filter", value: "Filter" },
                { label: "Search Bar", value: "Search Bar" },
                { label: "Column Show", value: "Column Show" },
                { label: "Column Hide", value: "Column Hide" },
                { label: "Input Field", value: "Input Field" },
                { label: "Table", value: "Table" },
                { label: "Graph Analysis", value: "Graph Analysis" },
                { label: "Data List", value: "Data List" },
                { label: "Print Preview", value: "Print Preview" },
                { label: "Export", value: "Export" },
                { label: "Bulk Actions", value: "Bulk Actions" },
                { label: "Forms", value: "Forms" },
                { label: "Pagination", value: "Pagination" },
                { label: "Attachments", value: "Attachments" },
                { label: "Import", value: "Import" },
                { label: "Bulk Update", value: "Bulk Update" },
                { label: "Parameter", value: "Parameter" }
            ],
            customizationFilterOptions: [
                { label: "Institute", value: "Institute" },
                { label: "Department", value: "Department" },
                { label: "Employee", value: "Employee" }
            ],
            applicationTypeFilterOptions: [
                { label: "Web Application", value: "Web Application" },
                { label: "Android Application", value: "Android Application" },
                { label: "IOS Application", value: "IOS Application" },
            ],
            modulesFetching: false,
            moduleList: {},
            subscriptionModuleList: {},
            selectedModuletab: this.props.selectedModuletab,

            enhancementAdding: false,
            previousAttachmentFileNameArray: this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0 ? Object.values(this.props.currentClientResponse)[0].attachments : [],
            // Modified/Added states for attachment handling:
            // Modified/Added states for attachment handling:
            currentFileSelected: null, // Currently selected file object
            currentFileName: '', // Name of currently selected file
            currentLocation: '', // Current location input value
            locationWarning: '', // Location validation message
            attachmentWarning: '', // Attachment validation message
            completedAttachments: [], // Array of completed {file, location, fileName} objects
            showAddMore: false, // Show "Add More" button when first attachment is ready



        }

    }
    componentDidMount() {
        this.apiCallToGetSubModuleList();
        this.apiCallToSubscriptionModuleList();
    }


    //         "iid": config.institute_id,
    //     };

    //     let jsonResponse = await HelpdeskApiCall.makeApiCall(
    //         'GetPMCurrentSubscriptionWiseModuleList',
    //         requestData,
    //         '/api/helpDesk/employee/Onboarding.php'
    //     );

    //     if (jsonResponse.expired) {
    //         setTimeout(() => {
    //             this.apiCallToSubscriptionModuleList()
    //         }, 1000);
    //     } else {
    //         if (jsonResponse.success) {
    //             let apiResult = jsonResponse.APIResult.data;

    //             let selectedModuletab = this.state.selectedModuletab;
    //             selectedModuletab = "";
    //             let moduleId = this.state.moduleId;
    //             moduleId = "";

    //             if (Object.keys(apiResult).length > 0) {
    //                 selectedModuletab = Object.values(apiResult)[0]['module_name'];
    //                 moduleId = Object.values(apiResult)[0]['moduleId'];
    //             }

    //             this.setState({
    //                 subscriptionModuleList: apiResult,
    //                 selectedModuletab,
    //                 moduleId
    //             });
    //         } else {
    //             this.setState({
    //                 successModal: true,
    //                 successModalType: 'error',
    //                 successMessage: 'Something went wrong while getting subscription module list. Please try again later.'
    //             });
    //         }
    //     }
    // }

    // API METHOD CALL TO GET SUBSCRIPTION MODULE LIST
    apiCallToSubscriptionModuleList = async () => {
        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetHelpDeskModuleList',
            requestData,
            '/api/helpDesk/employee/moduleInformation.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToSubscriptionModuleList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                this.setState({
                    subscriptionModuleList: apiResult,
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting subscription module list. Please try again later.'
                });
            }
        }
    }



    // API METHOD CALL TO GET MODULE LIST
    apiCallToGetSubModuleList = async () => {
        this.setState({
            modulesFetching: true
        });

        let requestData = {
            module_id: this.state.moduleId,
        }
        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'getHelpDeskSubModulesList',
            requestData,
            '/api/helpDesk/employee/Queries.php'
        );


        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetSubModuleList()
            }, 1000);
        } else {
            if (jsonResponse.success) {

                let apiResult = jsonResponse.APIResult.data;

                this.setState({
                    moduleList: apiResult,
                    modulesFetching: false,
                });
            } else {
                this.setState({
                    modulesFetching: false,
                    // successModalType: 'error',
                    // successMessage: 'Something went wrong while getting module list. Please try again later.'
                });
                console.log("Error in getting Module List");
            }
        }
    }

    apiCallToAddSrForEnhancements = async () => {
        this.setState({
            enhancementAdding: true
        })

        try {
            let userId = config.faculty_id;
            let formData = new FormData();
            const requestData = {
                "userRole": "Instructor",
                "iid": config.institute_id,
                "userUid": config.faculty_id,
                "querySubject": this.state.serviceRequestTitle,
                "queryDescription": this.state.explanation,
                "purpose": this.state.purpose,
                "queryType": "enhancements",
                "moduleId": this.state.moduleId,
                "subModuleId": this.state.subModuleId,
                "currentFeature": this.state.currentFlow?.trim(),
                "desiredFeature": this.state.featureFlow?.trim(),
                "moduleName": this.state.selectedModuletab,
                "targetElement": this.state.selectedTargetElements.map((element) => element.value).join(","),
                "changeImpactOn": this.state.customizationImpacts.map((element) => element.value).join(","),
                "Query_occurred_in": this.state.applicationTypes.map((element) => element.value),
                "acYr": config.instructorInfo.AcaYearId,
                "accountType": this.state.accountType,
                "attachmentFileArray": this.state.locationObjectArray,

            }


            // debugger;
            formData.append('helpDesk_addClientServiceRequest', true);
            formData.append('data', Base64.encode(JSON.stringify(requestData)));


            let parameterData = JSON.stringify({
                source: 'app',
                uid: userId,
                email: config.emailId,
                role: 'instructor'
            });
            formData.append('tokenInputParameter', Base64.encode(parameterData));

            this.state.attachmentFileArray.forEach((attachment) => {
                if (attachment.file) {
                    formData.append('file[]', attachment.file);
                } else {
                    console.error("File object is missing for attachment:", attachment);
                }
            });

            const headers = {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
                "Authorization": "Basic " + config.user_token
            };

            // Send the API request
            const response = await axios.post(config.RootUrl + '/api/helpDesk/clientServiceRequest/help_deskClientServiceRequest.php', formData, { headers });
            // Handle the API response
            let jsonResponse = response.data;
            if (jsonResponse.status === 'success') {
                toast.success(jsonResponse.message);
                this.setState({
                    enhancementAdding: false
                }, () => {
                    this.props.onCloseModal();
                })

            } else {
                this.setState({
                    enhancementAdding: false
                })
                toast.error(jsonResponse.message);
                // this.props.onCloseModal();
            }
        } catch (error) {
            toast.error('Something went wrong while adding design Request count. Please try again later.')

            this.setState({
                enhancementAdding: false
            }, () => {
                this.props.onCloseModal();
            })
            // this.setState({ executiveResponseFetching: false });

        }
    };
    apiCallToReRaiseSrForEnhancements = async () => {
        this.setState({
            enhancementAdding: true
        })

        try {
            let userId = config.faculty_id;
            let formData = new FormData();
            const requestData = {
                "userRole": "Instructor",
                "iid": config.institute_id,
                "userUid": config.faculty_id,
                "querySubject": this.state.serviceRequestTitle,
                "queryDescription": this.state.explanation,
                "purpose": this.state.purpose,
                "queryType": "enhancements",
                "moduleId": this.state.moduleId,
                "subModuleId": this.state.subModuleId,
                "currentFeature": this.state.currentFlow?.trim(),
                "desiredFeature": this.state.featureFlow?.trim(),
                "moduleName": this.state.selectedModuletab,
                "targetElement": this.state.selectedTargetElements.map((element) => element.value).join(","),
                "changeImpactOn": this.state.customizationImpacts.map((element) => element.value).join(","),
                "Query_occurred_in": this.state.applicationTypes.map((element) => element.value),
                "acYr": config.instructorInfo.AcaYearId,
                "accountType": this.state.accountType,
                "attachmentFileArray": this.state.locationObjectArray,
                "previousAttachmentFileNameArray": this.state.previousAttachmentFileNameArray,
                "sr_unique_id": Object.values(this.props.currentClientResponse)[0].serviceRequestId,

            }


            // debugger;
            formData.append('helpDesk_reopenClientServiceRequest', true);
            formData.append('data', Base64.encode(JSON.stringify(requestData)));


            let parameterData = JSON.stringify({
                source: 'app',
                uid: userId,
                email: config.emailId,
                role: 'instructor'
            });
            formData.append('tokenInputParameter', Base64.encode(parameterData));

            this.state.attachmentFileArray.forEach((attachment) => {
                if (attachment.file) {
                    formData.append('file[]', attachment.file);
                } else {
                    console.error("File object is missing for attachment:", attachment);
                }
            });

            const headers = {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
                "Authorization": "Basic " + config.user_token
            };

            // Send the API request
            const response = await axios.post(config.RootUrl + '/api/helpDesk/clientServiceRequest/help_deskClientServiceRequest.php', formData, { headers });

            // Handle the API response
            let jsonResponse = response.data;
            if (jsonResponse.status === 'success') {
                toast.success(jsonResponse.message);
                this.setState({
                    enhancementAdding: false
                }, () => {
                    this.props.onCloseModal();
                })

            } else {
                this.setState({
                    enhancementAdding: false
                })
                toast.error(jsonResponse.message);
                // this.props.onCloseModal();
            }
        } catch (error) {
            toast.error('Something went wrong while adding Enhancements Request count. Please try again later.')

            this.setState({
                enhancementAdding: false
            }, () => {
                this.props.onCloseModal();
            })
            // this.setState({ executiveResponseFetching: false });

        }
    };



    // Handle file selection - Saves file to state and shows location input
    handleFileUpload = (e) => {
        const files = Array.from(e.target.files);

        if (files.length === 0) {
            return;
        }

        const selectedFile = files[0];

        this.setState({
            currentFileSelected: selectedFile,
            currentFileName: selectedFile.name,
            currentLocation: '', // Reset location for new file
            locationWarning: '', // Clear warnings
            attachmentWarning: '',
            showAddMore: false // Hide "Add More" until location is entered
        });
    };

    // Handle location input change - Enables "Add More" when location is entered
    handleLocationChange = (e) => {
        const locationValue = e.target.value;

        this.setState({
            currentLocation: locationValue,
            locationWarning: '',
           attachmentWarning:'',
            // Show "Add More" button only if both file and location are present
            showAddMore: this.state.currentFileSelected && locationValue.trim() !== ''
        });
    };

    // Handle "Add More" click - Validates and saves current attachment, then resets for new one
    handleAddMoreClick = () => {
        const { currentFileSelected, currentFileName, currentLocation, completedAttachments, locationObjectArray, attachmentFileArray } = this.state;

        // Validate current file is selected
        if (!currentFileSelected) {
            toast.error('Please select a file first.');
            return;
        }

        // Validate current location is entered
        if (!currentLocation || currentLocation.trim() === '') {
            this.setState({ locationWarning: 'Location is required before adding more attachments.' });
            return;
        }

        // Check for duplicate files in completed attachments
        const isDuplicate = completedAttachments.some(att => att.fileName === currentFileName);
        if (isDuplicate) {
            toast.error('This file has already been added.');
            return;
        }

        // Create attachment object
        const newAttachment = {
            file: currentFileSelected,
            fileName: currentFileName,
            location: currentLocation,
            id: Date.now()
        };

        // Add to completed attachments array
        const updatedCompletedAttachments = [...completedAttachments, newAttachment];

        // Update locationObjectArray for API
        const newLocationObject = { [currentFileName]: currentLocation };
        const updatedLocationObjectArray = [...locationObjectArray, newLocationObject];

        // Update attachmentFileArray for API
        const updatedAttachmentFileArray = [...attachmentFileArray, {
            id: newAttachment.id,
            name: currentFileName,
            file: currentFileSelected
        }];

        // Reset file input
        if (this.fileInputRef.current) {
            this.fileInputRef.current.value = '';
        }

        // Reset state for next attachment
        this.setState({
            completedAttachments: updatedCompletedAttachments,
            locationObjectArray: updatedLocationObjectArray,
            attachmentFileArray: updatedAttachmentFileArray,
            currentFileSelected: null,
            currentFileName: '',
            currentLocation: '',
            locationWarning: '',
            attachmentWarning: '',
            showAddMore: false
        });

        // toast.success('Attachment saved! You can add more or submit the request.');
    };

    // Delete completed attachment from list
    handleDeleteAttachment = (index) => {
        const { completedAttachments, locationObjectArray, attachmentFileArray } = this.state;

        this.setState({
            completedAttachments: completedAttachments.filter((_, i) => i !== index),
            locationObjectArray: locationObjectArray.filter((_, i) => i !== index),
            attachmentFileArray: attachmentFileArray.filter((_, i) => i !== index)
        });

        toast.info('Attachment removed.');
    };

    // Delete previous attachment (for re-raise case)
    deletePreviousAttachment = (index) => {
        let previousAttachmentFileNameArray = [...this.state.previousAttachmentFileNameArray];
        previousAttachmentFileNameArray.splice(index, 1);
        this.setState({ previousAttachmentFileNameArray });
    };
    validateAddExecutiveResponse = () => {
        let isValid = true;
        if (this.state.serviceRequestTitle.trim() === '') {
            isValid = false;
            // serviceRequestTitleWarning
            this.setState({

                serviceRequestTitleWarning: 'Service Request Title is required'
            }
            )
        }
        if (this.state.explanation.trim() === '') {
            isValid = false;

            this.setState({

                explanationWarning: 'Description is required'
            }
            )


        }
        // applicationTypes
        if (this.state.applicationTypes.length < 1) {
            isValid = false;
            this.setState({

                applicationTypeWarning: 'Application Type is required'
            }
            )
        }
        // if (this.state.currentFlow.trim() === '') {
        //     isValid = false;
        //     toast.error('Current Flow is required');
        // }
        // if (this.state.featureFlow.trim() === '') {
        //     isValid = false;
        //     toast.error('Desired Flow is required');
        // }
        if (this.state.customizationImpacts.length < 1) {
            isValid = false;
            this.setState({

                customizationImpactsWarning: 'Please Select Customization Type '
            }
            )
        }

        if (this.state.selectedTargetElements.length < 1) {
            isValid = false;
            this.setState({ targetElementsWarning: 'Target Element is required' })

        }

        if (this.state.accountType < 1) {
            isValid = false;
            this.setState({ accountTypeWarning: 'Account Type is required' })

        }
        // subModuleWarning
        if (this.state.subModuleId === '') {
            isValid = false;
            this.setState({ subModuleWarning: 'Sub Module  is required' })
        }

        // Check if user has unsaved attachment (file selected but not added via "Add More")
        if (this.state.currentFileSelected && this.state.currentLocation) {
            // Auto-save the current attachment before validation
            const newAttachment = {
                file: this.state.currentFileSelected,
                fileName: this.state.currentFileName,
                location: this.state.currentLocation,
                id: Date.now()
            };

            const newLocationObject = { [this.state.currentFileName]: this.state.currentLocation };

            this.setState(prevState => ({
                completedAttachments: [...prevState.completedAttachments, newAttachment],
                locationObjectArray: [...prevState.locationObjectArray, newLocationObject],
                attachmentFileArray: [...prevState.attachmentFileArray, {
                    id: newAttachment.id,
                    name: this.state.currentFileName,
                    file: this.state.currentFileSelected
                }],
                currentFileSelected: null,
                currentFileName: '',
                currentLocation: '',

            }), () => {
                // After state update, continue with submission validation
                this.continueValidation(isValid);
            });
            return;
        }

        this.continueValidation(isValid);
    };

    // Continue validation after auto-saving current attachment
    continueValidation = (isValid) => {
        // Validate attachments - At least one complete attachment required
        const hasNewAttachments = this.state.completedAttachments.length > 0 || this.state.locationObjectArray.length > 0;
        const hasPreviousAttachments = this.props.currentClientResponse &&
            Object.values(this.props.currentClientResponse).length > 0 &&
            this.state.previousAttachmentFileNameArray.length > 0;

        if (!hasNewAttachments && !hasPreviousAttachments) {
            isValid = false;
            this.setState({
                attachmentWarning: 'At least one attachment with location is required.'
            });
        }

        // Check if file is selected but location is missing
        if (this.state.currentFileSelected && !this.state.currentLocation) {
            isValid = false;
            this.setState({
                locationWarning: 'Please enter location for the selected file.',
                attachmentWarning: 'Please complete the current attachment (enter location) before submitting.'
            });
        }

        if (isValid) {
            if (this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0) {
                this.apiCallToReRaiseSrForEnhancements();
            } else {
                this.apiCallToAddSrForEnhancements();
            }
        }
    };




    // METHOD TO GET MODULE
    getModule = (e) => {
        this.setState({
            moduleId: e.target.value
        }, () => this.apiCallToGetAddSubModuleList());

        if (e.target.value.length < 1) {
            this.setState({
                moduleWarning: 'Please select module.',
                moduleName: ''
            });
        } else {
            this.setState({
                moduleWarning: '',
                moduleName: e.target.selectedOptions[0].text
            });
        }
    }






    hadnleTargetElements = (selectedOptions) => {

        this.setState({
            selectedTargetElements: selectedOptions || [], // Handle empty selection
            targetElementsWarning: selectedOptions && selectedOptions.length > 0 ? '' : 'Please target elements'
        });

    };

    handleCustomizationMemberChange = (selectedOptions) => {
        this.setState({
            customizationImpacts: selectedOptions || [],
            customizationImpactsWarning: selectedOptions && selectedOptions.length > 0 ? '' : 'Please select customization type'
        });
    }

    handleApplicationTypeChange = (selectedOptions) => {
        this.setState({
            applicationTypes: selectedOptions || [],
            applicationTypeWarning: selectedOptions && selectedOptions.length > 0 ? '' : 'Please select application type'
        });
    }


    render() {
        return (
            <div>

                <div className="client-request-modal-body client-request-body">

                    {/* <div className="client-request-form-group">
                                <label>Service Consumption Percentage</label>
                                <p className="percentage">12% Consumed Customization.</p>
                            </div> */}
                    <div className="form-group client-request-form-group">
                        <p className='vm_custom_body5' style={{ color: '#000000' }}>Title/Problem Statement  <span style={{ color: 'red' }}>*</span></p>
                        <input type="text" style={{ height: '40px' }} name="title" className='form-control problem-form-control' placeholder="Enter problem statement" value={this.state.serviceRequestTitle} onChange={(e) => this.setState({ serviceRequestTitle: e.target.value, serviceRequestTitleWarning: e.target.value.length > 0 ? '' : 'Service request title is required' })} />
                        <p className="text-danger" style={{ fontSize: 14 }}>
                            {this.state.serviceRequestTitleWarning}
                        </p>

                    </div>
                    <div className="form-group client-request-form-group">
                        <p className='vm_custom_body5' style={{ color: '#000000' }}>Problem Description  <span style={{ color: 'red' }}>*</span></p>
                        <textarea name="explanation" className='form-control explanation-form-control' placeholder="Enter Explanation" value={this.state.explanation} onChange={(e) => this.setState({ explanation: e.target.value, explanationWarning: e.target.value.length > 0 ? '' : 'description is required' })}></textarea>
                        <p className="text-danger" style={{ fontSize: 14 }}>
                            <p className="text-danger" style={{ fontSize: 14 }}>
                                {this.state.explanationWarning}
                            </p>
                        </p>
                    </div>
                    <div className="form-group client-request-form-group">
                        <p className='vm_custom_body5' style={{ color: '#000000' }}>Purpose
                        </p>
                        <textarea name="explanation" className='form-control explanation-form-control' placeholder="Enter explanation"
                            value={this.state.purpose} onChange={(e) => this.setState({ purpose: e.target.value, purposeWarning: e.target.value.length > 0 ? '' : 'Purpose is required' })}></textarea>
                        <p className="text-danger" style={{ fontSize: 14 }}>
                            {this.state.purposeWarning}
                        </p>

                    </div>
                    <div className="client-request-form-row queryType">
                        <div className="form-group client-request-form-group" style={{ width: '50%' }}>
                            <p className='vm_custom_body5' style={{ color: '#000000' }}>Module <span style={{ color: 'red' }}>*</span></p>
                            <select
                                disabled={true}
                                style={{ fontSize: "13px" }}
                                className="form-control"
                                value={this.state.moduleId}
                                onChange={(e) => this.getModule(e)}
                            >
                                <option style={{ fontSize: "13px" }} value="">Select Module</option>
                                {
                                    Object.keys(this.state.subscriptionModuleList).length > 0 &&
                                    Object.values(this.state.subscriptionModuleList).map(module => {
                                        return (
                                            <option key={module.moduleId} value={module.moduleId}>{module.module_name}</option>
                                        );

                                    })
                                }
                            </select>
                            <p className="text-danger" style={{ fontSize: 14 }}>{this.state.moduleWarning}</p>
                        </div>

                        <div className="form-group client-request-form-group" style={{ width: '50%' }}>
                            <p className='vm_custom_body5' style={{ color: '#000000' }}>Sub Module of {this.state.selectedModuletab}  Module <span className="required">*</span></p>
                            <select style={{ fontSize: '14px' }} className="form-control custom-request-form-control"
                                // Value and onchange
                                value={this.state.subModuleId}
                                onChange={(e) => this.setState({ subModuleId: e.target.value, subModuleWarning: e.target.value > 0 ? '' : 'Select Sub Module' })}
                            >


                                <option className='request-form-size' style={{ fontSize: '13px' }}>Select Sub Module Name</option>
                                {
                                    Object.keys(this.state.moduleList).length > 0 &&
                                    Object.values(this.state.moduleList).map(module => {
                                        return (
                                            <option style={{ fontSize: "13px" }} key={module.uniqueId} value={module.uniqueId}>
                                                {module.subModuleName}
                                            </option>
                                        );
                                    })
                                }
                            </select>
                            <p className="text-danger" style={{ fontSize: 14 }}>{this.state.subModuleWarning}</p>
                        </div>
                    </div>
                    <div className="client-request-form-row queryType">
                        <div className="client-request-form-group" style={{ width: '50%' }}>
                            <p className='vm_custom_body5' style={{ color: '#000000' }}>Application Type <span style={{ color: 'red' }}>*</span> </p>
                            <div className="input-group input-group-field" style={{ position: 'relative' }}>

                                <Select
                                    isMulti
                                    name="applicationTypeFilterOptions"
                                    options={this.state.applicationTypeFilterOptions}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    onChange={this.handleApplicationTypeChange} // Capture selected options
                                    value={this.state.applicationTypes} // Bind the selected options
                                    placeholder="Search and select application types..."

                                    isSearchable


                                    styles={{
                                        multiValue: (base) => ({
                                            ...base,
                                            backgroundColor: 'none', // Green background for selected chips
                                            borderRadius: '5px',
                                            border: '1px solid #c4c5c5',
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            color: '#808080'

                                        }),

                                        placeholder: (base) => ({
                                            ...base,
                                            fontSize: '14px',
                                            fontWeight: '400', // Use fontWeight for normal text

                                        }),
                                        option: (base, state) => ({
                                            ...base,
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                            color: state.isSelected ? '#333' : '#555',
                                        }),

                                    }}
                                // noOptionsMessage={() => (this.state.isLoading ? "Loading..." : "No options found")}
                                />
                            </div>

                            <p className="text-danger" style={{ fontSize: 14 }}>{this.state.applicationTypeWarning}</p>
                        </div>
                        <div className="client-request-form-group" style={{ width: '50%' }}>
                            <p className='vm_custom_body5' style={{ color: '#000000' }}>Customization impact to <span style={{ color: 'red' }}>*</span></p>
                            <div className="input-group input-group-field" style={{ position: 'relative' }}>

                                <Select
                                    isMulti
                                    name="teamMembers"
                                    options={this.state.customizationFilterOptions}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    onChange={this.handleCustomizationMemberChange} // Capture selected options
                                    value={this.state.customizationImpacts} // Bind the selected options
                                    placeholder="Search and select customizations..."

                                    isSearchable


                                    styles={{
                                        multiValue: (base) => ({
                                            ...base,
                                            backgroundColor: 'none', // Green background for selected chips
                                            borderRadius: '5px',
                                            border: '1px solid #c4c5c5',
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            color: '#808080'

                                        }),

                                        placeholder: (base) => ({
                                            ...base,
                                            fontSize: '14px',
                                            fontWeight: '400', // Use fontWeight for normal text

                                        }),
                                        option: (base, state) => ({
                                            ...base,
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                            color: state.isSelected ? '#333' : '#555',
                                        }),

                                    }}
                                // noOptionsMessage={() => (this.state.isLoading ? "Loading..." : "No options found")}
                                />
                            </div>
                            <p className="text-danger" style={{ fontSize: 14 }}>{this.state.customizationImpactsWarning}</p>
                        </div>

                    </div>
                    <div className="client-request-form-row queryType">
                        <div className="client-request-form-group" style={{ width: '50%' }}>
                            <p className='vm_custom_body5' style={{ color: '#000000' }}>Target Elements <span style={{ color: 'red' }}>*</span></p>
                            <div className="input-group input-group-field" style={{ position: 'relative' }}>

                                <Select
                                    isMulti
                                    name="teamMembers"
                                    options={this.state.filterOptions}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    onChange={this.hadnleTargetElements} // Capture selected options
                                    value={this.state.selectedTargetElements} // Bind the selected options
                                    placeholder="Search and select Target elements..."

                                    isSearchable


                                    styles={{
                                        multiValue: (base) => ({
                                            ...base,
                                            backgroundColor: 'none', // Green background for selected chips
                                            borderRadius: '5px',
                                            border: '1px solid #c4c5c5',
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            color: '#808080'

                                        }),

                                        placeholder: (base) => ({
                                            ...base,
                                            fontSize: '14px',
                                            fontWeight: '400', // Use fontWeight for normal text

                                        }),
                                        option: (base, state) => ({
                                            ...base,
                                            fontSize: '14px',
                                            fontWeight: '400',
                                            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                            color: state.isSelected ? '#333' : '#555',
                                        }),

                                    }}
                                // noOptionsMessage={() => (this.state.isLoading ? "Loading..." : "No options found")}
                                />
                            </div>
                            <p className="text-danger" style={{ fontSize: 14 }}>{this.state.targetElementsWarning}</p>
                        </div>
                        <div className="form-group client-request-form-group" style={{ width: '50%' }}>
                            <p className='vm_custom_body5' style={{ color: '#000000' }} >Account Type <span style={{ color: 'red' }}>*</span></p>
                            <select
                                type="text"
                                style={{ fontSize: '14px' }}
                                className="form-control custom-request-form-control"
                                value={this.state.accountType}
                                onChange={(e) => this.setState({ accountType: e.target.value, accountTypeWarning: e.target.value.length > 0 ? '' : 'Account Type is required' })}
                            >
                                <option className='vm_custom_body5' style={{ color: '#000000' }} value="">Select Account Type</option>
                                <option className='vm_custom_body5' style={{ color: '#000000' }} value="faculty">Faculty</option>
                                <option value="Student">Student</option>
                                <option value="Parent">Parent</option>
                            </select>
                            <p className="text-danger" style={{ fontSize: 14 }}>{this.state.accountTypeWarning}</p>
                        </div>


                    </div>


                    <div className="client-request-form-group" style={{ width: '100%' }}>
                        <p className='vm_custom_body5' style={{ color: '#000000' }}>How are you using current feature/ flow?</p>
                        <textarea name="explanation" className='form-control featureFlow-form-control' placeholder="Enter remark" value={this.state.featureFlow} onChange={(e) => this.setState({ featureFlow: e.target.value })}></textarea>
                        <p className="text-danger" style={{ fontSize: 14 }}>{this.state.currentFlowWarning}</p>
                    </div>
                    <div className="client-request-form-group" style={{ width: '100%' }}>
                        <p className='vm_custom_body5' style={{ color: '#000000' }}>What is desired feature/ flow? </p>
                        <textarea name="explanation" className='form-control featureFlow-form-control' placeholder="Enter remark" value={this.state.currentFlow} onChange={(e) => this.setState({ currentFlow: e.target.value })}></textarea>
                        <p className="text-danger" style={{ fontSize: 14 }}>{this.state.featureFlowWarning}</p>
                    </div>

                    {/* Previous Attachments Section - Only for Re-raise case */}
                    {this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0 &&
                        this.state.previousAttachmentFileNameArray.length > 0 && (
                            <div className="attachment-list" style={{ marginBottom: '20px' }}>
                                <p className='vm_custom_body5' style={{ color: '#000000' }}>Previous Attachments</p>
                                {this.state.previousAttachmentFileNameArray.map((attachment, index) => (
                                    <div
                                        key={index}
                                        title={'view image'}
                                        className="request-attachment-item"
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            padding: '10px',
                                            border: '1px solid #ddd',
                                            borderRadius: '5px',
                                            marginBottom: '10px',
                                            cursor: 'pointer',
                                            backgroundColor: '#f9f9f9'
                                        }}
                                        onClick={() => this.viewAttachmentClick(attachment)}
                                    >
                                        <span className='vm_custom_body5'>📎 {attachment.fileName}</span>
                                        <FontAwesomeIcon
                                            icon={faTrash}
                                            className="delete-icon"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                this.deletePreviousAttachment(index);
                                            }}
                                            style={{ cursor: 'pointer', color: '#dc3545' }}
                                        />
                                    </div>
                                ))}
                            </div>
                        )}

                    {/* Attachment Section */}
                    <div className="attachment-section">
                        <p className='vm_custom_body5' style={{ color: '#000000' }}>
                            Attachment <span style={{ color: 'red' }}>*</span>
                        </p>

                        <div className="executive-attachment-upload">
                            {/* Upload Box */}
                            <div
                                className="pre-upload-box"
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: "12px",
                                    padding: "15px",
                                    border: "1px solid #ddd",
                                    borderRadius: "8px",
                                    backgroundColor: "#f9f9f9"
                                }}
                            >
                                {/* File Selection Row */}
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                                    {/* Choose File Button */}
                                    <button
                                        onClick={() => this.fileInputRef.current.click()}
                                        className="executive-browse-button"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            padding: "8px 14px",
                                            borderRadius: "6px",
                                            border: "1px solid #0465ac",
                                            backgroundColor: "#fff",
                                            color: '#0465ac',
                                            cursor: "pointer",
                                            fontSize: "14px",
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faUpload} style={{ fontSize: "14px" }} />
                                        <span className='vm_custom_body10'>Choose File</span>
                                    </button>

                                    {/* Hidden File Input */}
                                    <input
                                        type="file"
                                        ref={this.fileInputRef}
                                        style={{ display: "none" }}
                                        onChange={this.handleFileUpload}
                                    />

                                    {/* Show Selected File Name */}
                                    {this.state.currentFileName && (
                                        <span className='vm_custom_body10' style={{ color: '#666', fontStyle: 'italic' }}>
                                            Selected: <strong>{this.state.currentFileName}</strong>
                                        </span>
                                    )}
                                </div>

                                {/* Location Input Row - Shows when file is selected */}
                                {this.state.currentFileSelected && (
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '8px',
                                        width: '100%'
                                    }}>
                                        <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                                            {/* Location Input Field */}
                                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                                                <label className='vm_custom_body10' style={{ marginBottom: '5px' }}>
                                                    Location <span style={{ color: 'red' }}>*</span>
                                                </label>
                                                <input
                                                    style={{
                                                        width: '100%',
                                                        fontSize: '14px',
                                                        padding: '8px',
                                                        borderRadius: '4px',
                                                        border: '1px solid #ddd'
                                                    }}
                                                    className="form-control location-field-input poppins"
                                                    type="text"
                                                    placeholder="Enter location path of error screen"
                                                    value={this.state.currentLocation}
                                                    onChange={this.handleLocationChange}
                                                />
                                                {this.state.locationWarning && (
                                                    <span className='vm_custom_body8 text-danger' style={{ marginTop: '5px',fontSize:'14px' }}>
                                                        {this.state.locationWarning}
                                                    </span>
                                                )}
                                            </div>


                                        </div>

                                    </div>
                                )}

                                {/* Add More Button - Shows only when both file and location are present */}
                                {this.state.showAddMore && (
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <label style={{ marginBottom: '5px', visibility: 'hidden' }}>.</label>
                                        <span
                                        className='poppins'
                                            style={{


                                                backgroundColor: "#fff",
                                                color: '#0465ac',
                                                cursor: 'pointer',
                                                whiteSpace: 'nowrap',
                                                fontWeight: 'bold',
                                                fontSize: '14px',
                                                textDecoration: 'underline',
                                            }}
                                            onClick={this.handleAddMoreClick}
                                        >
                                            + Add More
                                        </span>
                                    </div>
                                )}
                            </div>

                            {/* Attachment Validation Warning */}
                            {this.state.attachmentWarning && (
                                <span className='vm_custom_body8 text-danger' style={{ display: 'block', marginTop: '8px',fontSize:'14px' }}>
                                    {this.state.attachmentWarning}
                                </span>
                            )}

                            {/* Completed Attachments List */}
                            {this.state.completedAttachments.length > 0 && (
                                <div className="attachment-list" style={{ marginTop: '15px' }}>
                                    <p className='vm_custom_body5' style={{ color: '#000000', marginBottom: '10px' }}>
                                        Attachment List ({this.state.completedAttachments.length})
                                    </p>
                                    {this.state.completedAttachments.map((attachment, index) => (
                                        <div
                                            key={attachment.id || index}
                                            className="request-attachment-item"
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'flex-start',
                                                padding: '12px',
                                                border: '1px solid #ddd',
                                                borderRadius: '6px',
                                                marginBottom: '10px',
                                                backgroundColor: '#fff'
                                            }}
                                        >
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                width: '100%',
                                                alignItems: 'center'
                                            }}>
                                                <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                                    <span className='vm_custom_body5' style={{ fontWeight: '600', marginBottom: '5px' }}>
                                                        📎 {attachment.fileName}
                                                    </span>
                                                    <span className='vm_custom_body10' style={{ fontSize: '12px', color: '#666' }}>
                                                        📍 Location: {attachment.location}
                                                    </span>
                                                </div>
                                                <FontAwesomeIcon
                                                    icon={faTrash}
                                                    className="delete-icon"
                                                    onClick={() => this.handleDeleteAttachment(index)}
                                                    style={{ cursor: 'pointer', color: '#dc3545', marginLeft: '10px', fontSize: '16px' }}
                                                    title="Delete attachment"
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>



                </div>

                <div className='modal-footer executive-response-footer'>
                    <button className='executive-custom-button executive-assign-btn' onClick={() => this.validateAddExecutiveResponse()} disabled={this.state.enhancementAdding}>

                        {this.state.enhancementAdding ? (
                            <span className="spinner-border spinner-border-sm text-grey" role="status" aria-hidden="true"></span>
                        ) : (
                            "Add Request"
                        )}
                    </button>
                    <button className='executive-custom-button executive-cancel-btn' disabled={this.state.enhancementAdding} onClick={() => this.props.onCloseModal()}>Cancel</button>


                </div>

            </div >
        )
    }
}

export default Enhancements
